import { features, navigationItems, product, securityPoints } from '../business/content/siteContent';
import { usePageNavigation } from '../business/navigation/usePageNavigation';
import { PageFooter } from '../components/layout/PageFooter';
import { PageHeader } from '../components/layout/PageHeader';
import { FeatureSection } from '../components/marketing/FeatureSection';
import { HeroSection } from '../components/marketing/HeroSection';
import { SecuritySection } from '../components/marketing/SecuritySection';
import './MainPage.css';

export function MainPage() {
  const { navigate } = usePageNavigation();

  return (
    <div className="site-shell">
      <PageHeader
        productName={product.name}
        items={navigationItems}
        onNavigate={navigate}
      />
      <main>
        <HeroSection
          product={product}
          onLearnMore={() => navigate({ target: 'features' })}
        />
        <FeatureSection features={features} />
        <SecuritySection points={securityPoints} />
      </main>
      <PageFooter productName={product.name} />
    </div>
  );
}
